import React from 'react';
import { IconProps } from '../types';
const MinecraftClock31: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="0" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="7" y="0" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="8" y="0" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="9" y="0" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(86, 86, 109, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(108, 108, 137, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(251, 247, 183, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(30, 28, 28, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(24, 22, 22, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(217, 148, 19, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(58, 83, 172, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(217, 148, 19, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(251, 247, 183, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(251, 247, 183, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(253, 245, 95, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(250, 214, 74, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(117, 40, 2, 255)" />
</svg>);
export default MinecraftClock31;